// NodeView.jsx

import React, { useMemo } from 'react';

// CSS
import './NodeView.css';

// Components
import NodeTypePill from 'components/nodetypepill/NodeTypePill';

/**
 * NodeView
 *
 * @returns {ReactNode} The rendered component.
 */
const NodeView = ({ node, onClick }) => {

  // ----- MEMOS ----- //

  // Determine whether this node itself is directly displayable media

  const slides = useMemo(() => {
    const effectiveType = node?.type;
    return [
      'PHOTO',
      'VIDEO',
      'POLL',
      'LIVE_ROOM', // intentionally excluded
    ].includes(effectiveType)
      ? [node]
      : [];
  }, [node]);

  // Fallback cover logic: only if there are NO displayable slides
  const coverFallback = useMemo(() =>
    slides.length === 0 &&
      typeof node?.coverUrl === 'string' &&
      node.coverUrl.trim().length > 0
      ? node.coverUrl
      : null,
    [slides.length, node?.coverUrl]
  );

  // ----- RENDER ----- //

  return (
    <div
      className="node-view-container"
      onClick={onClick}
    >

      {/* TOP */}
      {coverFallback &&

        <div className="node-view-top">
          <img
            src={coverFallback}
            alt=""
            aria-hidden="true"
            draggable="false"
            loading="lazy"
          />
        </div>
      }

      {/* FOOTER */}
      <div className="node-view-footer">

        {/* TITLE ROW*/}

        {/* TITLE ROW */}
        <div className="node-view-title-row">

          {/* TITLE */}
          {node.title && (
            <div className="node-view-title">
              {node.title}
            </div>
          )}

          {/* TYPE */}
          <div className="node-view-type">
            <NodeTypePill node={node} />
          </div>

        </div>

        {/* USER */}
        {node.user && node.user.name && (

          <div className="node-view-user">
            {node.user.name}
          </div>
        )}

      </div>

    </div>
  );
};

// Dev Tools
NodeView.displayName = 'NodeView';

export default NodeView;
